var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Content",
    { class: _vm.classNames, attrs: { "app-name": "calendar" } },
    [
      !_vm.isEmbedded
        ? _c(
            "AppNavigation",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "list",
                    fn: function() {
                      return [
                        _c("AppNavigationSpacer"),
                        _vm._v(" "),
                        _c("CalendarList", {
                          attrs: {
                            "is-public": !_vm.isAuthenticatedUser,
                            "loading-calendars": _vm.loadingCalendars
                          }
                        }),
                        _vm._v(" "),
                        !_vm.loadingCalendars && _vm.isAuthenticatedUser
                          ? _c("CalendarListNew", {
                              attrs: { disabled: _vm.loadingCalendars }
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "footer",
                    fn: function() {
                      return [
                        _vm.isAuthenticatedUser
                          ? _c("Settings", {
                              attrs: {
                                "loading-calendars": _vm.loadingCalendars
                              }
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2242494356
              )
            },
            [
              _c("AppNavigationHeader", {
                attrs: { "is-public": !_vm.isAuthenticatedUser }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEmbedded ? _c("EmbedTopNavigation") : _vm._e(),
      _vm._v(" "),
      _c(
        "AppContent",
        [
          _c("FullCalendar", {
            ref: "fullCalendar",
            attrs: {
              "default-view": _vm.defaultView,
              editable: _vm.isEditable,
              "force-event-duration": true,
              header: _vm.showHeader,
              height: _vm.windowResize,
              "slot-duration": _vm.slotDuration,
              "week-numbers": _vm.showWeekNumbers,
              weekends: _vm.showWeekends,
              "event-sources": _vm.eventSources,
              "event-order": _vm.eventOrder,
              plugins: _vm.plugins,
              "time-zone": _vm.timezoneId,
              "day-render": _vm.dayRender,
              "event-allow": _vm.eventAllow,
              "event-limit": _vm.eventLimit,
              "event-limit-text": _vm.eventLimitText,
              "default-date": _vm.defaultDate,
              locales: _vm.locales,
              locale: _vm.fullCalendarLocale,
              "first-day": _vm.firstDay,
              selectable: _vm.isSelectable,
              "time-grid-event-min-height": 16,
              "select-mirror": true,
              "lazy-fetching": false,
              "nav-links": true,
              "nav-link-day-click": _vm.navLinkDayClick,
              "nav-link-week-click": _vm.navLinkWeekClick,
              "now-indicator": true,
              "progressive-event-rendering": true,
              "unselect-auto": false,
              "week-numbers-within-days": true,
              "event-render": _vm.eventRender
            },
            on: {
              eventClick: _vm.eventClick,
              eventDrop: _vm.eventDrop,
              eventResize: _vm.eventResize,
              select: _vm.select
            }
          }),
          _vm._v(" "),
          _vm.showEmptyCalendarScreen ? _c("EmptyCalendar") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loadingCalendars ? _c("router-view") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }